import { FC, useEffect } from 'react';
import { Form, Typography } from 'antd';
import { useDispatch } from 'react-redux';

import { Verify2FAStepProps } from 'models/form';

import { CODE_LENGTH, Rules } from 'utils/constants';

import { CodeField, FormItem } from 'componets/form';

import { AppDispatch } from 'store';

import { useCodeForm, useTranslate } from 'hooks';

import { verify2FA } from 'features/verify2FA/actions';
import { setVerify2FAStep } from 'features/verify2FA/verify2FASlice';

import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg';

export const VerifyCode: FC<Verify2FAStepProps> = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { backText, enterCodeText, errorInvalidAuthCodeText } = useTranslate([
		'backText',
		'enterCodeText',
		'errorInvalidAuthCodeText',
	]);

	const { fields, disabled, setFields, setIsValid, isValid, setDisabled, code } = useCodeForm();

	useEffect(() => {
		if (isValid) {
			setDisabled(true);
			dispatch(verify2FA({ code: code.value }))
				.unwrap()
				.catch((e) => {
					setFields([{ ...code, errors: [errorInvalidAuthCodeText] }]);
					setDisabled(false);
					setIsValid(false);
				});
		}
	}, [code, dispatch, errorInvalidAuthCodeText, isValid, setDisabled, setFields, setIsValid]);

	return (
		<div className="modal-content">
			<Typography.Text className="modal-enterCode">{enterCodeText}</Typography.Text>
			<Form onFieldsChange={setFields} fields={fields} className="modal-form">
				<FormItem className="code" name="code" rules={[Rules.REQUIRED]}>
					<CodeField
						name="code"
						fields={CODE_LENGTH}
						disabled={disabled}
						autoComplete="one-time-code"
					/>
				</FormItem>
			</Form>
			<div className="modal-back">
				<button
					disabled
					className="modal-backButton"
					type="button"
					onClick={() => dispatch(setVerify2FAStep(1))}
				>
					<ArrowBack />
					{backText}
				</button>
			</div>
		</div>
	);
};
